import { QuizURL } from '@ts-types/quiz/url/enums'
import type { RouterConfig } from 'nuxt/schema'

const defaultQuiz = `/${QuizURL.RegistrationQuiz}`

export default {
  routes: (routes: any) => {
    return [
      ...routes,
      {
        name: 'index',
        path: '/',
        redirect: defaultQuiz
      },
      {
        name: 'demo',
        path: '/demo',
        redirect: defaultQuiz
      },
      {
        name: 'quiz15',
        path: '/quiz15',
        redirect: defaultQuiz
      },
      {
        name: 'quiz15can',
        path: '/quiz15can',
        redirect: defaultQuiz
      },
      {
        name: 'quiz16',
        path: '/quiz16',
        redirect: defaultQuiz
      },
      {
        name: 'quiz17',
        path: '/quiz17',
        redirect: defaultQuiz
      },
      {
        name: 'quiz18',
        path: '/quiz18',
        redirect: defaultQuiz
      },
      {
        name: 'quiz20',
        path: '/quiz20',
        redirect: defaultQuiz
      },
      {
        name: 'quiz30',
        path: '/quiz30',
        redirect: defaultQuiz
      },
      {
        name: 'quiz-short',
        path: '/quiz-short',
        redirect: defaultQuiz
      },
      {
        name: 'quiz-adhd',
        path: '/quiz-adhd',
        redirect: defaultQuiz
      },
      {
        name: 'quiz-summer-camp',
        path: '/quiz-summer-camp',
        redirect: defaultQuiz
      },
      {
        name: 'paid-quiz',
        path: '/paid-quiz',
        redirect: defaultQuiz
      },
      {
        name: 'personalized-quiz',
        path: '/personalized-quiz',
        redirect: defaultQuiz
      },
      {
        name: 'personalized-afterschool-quiz',
        path: '/personalized-afterschool-quiz',
        redirect: defaultQuiz
      },
      {
        name: 'personalized-school-stress-quiz',
        path: '/personalized-school-stress-quiz',
        redirect: defaultQuiz
      },
      {
        name: 'personalized-summer-quiz',
        path: '/personalized-summer-quiz',
        redirect: defaultQuiz
      },
      {
        name: 'personalized-winter-quiz',
        path: '/personalized-winter-quiz',
        redirect: defaultQuiz
      },
    ]
  }
} satisfies RouterConfig
